export const ScenarioOptimizationsActionTypes = {
    API_RESPONSE_SUCCESS: '@@scenario-optimizations/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@scenario-optimizations/API_RESPONSE_ERROR',
    GET_NO_SHIPMENTS_REQUEST: '@@scenario-optimizations/GET_NO_SHIPMENTS_REQUEST',
    GET_TOP_ZONE_REQUEST: '@@scenario-optimizations/GET_TOP_ZONE_REQUEST',
    GET_TOP_WEIGHT_REQUEST: '@@scenario-optimizations/GET_TOP_WEIGHT_REQUEST',
    GET_BASE_CHARGE_AMOUNT_REQUEST: '@@scenario-optimizations/GET_BASE_CHARGE_AMOUNT_REQUEST',
    GET_AVG_BASE_CHARGE_AMOUNT_REQUEST: '@@scenario-optimizations/GET_AVG_BASE_CHARGE_AMOUNT_REQUEST',
    GET_COMPARISON_ANALYTICS_RECORDS: '@@scenario-optimizations/GET_COMPARISON_ANALYTICS_RECORDS',
    GET_COMPARISON_ANALYTICS_REPORT: '@@scenario-optimizations/GET_COMPARISON_ANALYTICS_REPORT',
    GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT: '@@scenario-optimizations/GET_COMPARISON_RATES_BASE_CHARGE_AMOUNT',
    GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT: '@@scenario-optimizations/GET_COMPARISON_RATES_AVG_BASE_CHARGE_AMOUNT',
    GET_COUNT_BY_WEIGHT_AND_ZONE: '@@scenario-optimizations/GET_COUNT_BY_WEIGHT_AND_ZONE',
};
